import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import EmployeeJobDiaryDetailItem from '../entities/employee-job/employee-job-diary-detail';
import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import appconst from './../../lib/appconst';
interface EmployeeJobDiaryDetailState extends ListState<EmployeeJobDiaryDetailItem> {
	employeeId: number;
	employeeName: string;
}
class EmployeeJobDiaryDetailModule extends ListModule<EmployeeJobDiaryDetailState, any, EmployeeJobDiaryDetailItem> {
	state = {
		totalCount: 0,
		currentPage: 1,
		pageSize: 10,
		list: new Array<EmployeeJobDiaryDetailItem>(),
		loading: false,
	};
	actions = {
		async getAll(context: ActionContext<EmployeeJobDiaryDetailState, any>, payload: any) {
			context.state.loading = true;
			const {
				data: { result },
			} = await Ajax.get('/api/services/app/report/EmployeeJobDiaryDetail', { params: payload.data });
			context.state.loading = false;
			const page = result as PageResult<EmployeeJobDiaryDetailItem>;
			context.state.totalCount = page.totalCount;
			context.state.list = page.items;
		},
		async exportEmployeeJobDiaryDetail(context: ActionContext<EmployeeJobDiaryDetailState, any>, payload: any) {
			var url = `${appconst.remoteServiceBaseUrl}report/ExportEmployeeJobDiaryDetail${abp.utils.buildQueryString(
				Object.keys(payload.data).map(key => {
					return {
						name: key,
						value: payload.data[key],
					};
				}),
				true
			)}`;
			window.open(url, '_blank');
		},
	};
	mutations = {
		setCurrentPage(state: EmployeeJobDiaryDetailState, page: number) {
			state.currentPage = page;
		},
		setPageSize(state: EmployeeJobDiaryDetailState, pagesize: number) {
			state.pageSize = pagesize;
		},
	};
}
const employeeJobDiaryModule = new EmployeeJobDiaryDetailModule();
export default employeeJobDiaryModule;
